module.exports = __webpack_public_path__ + "static/13-097171f8b42e3cc85c15ffa9ff50f1f1.jpg";